import React from 'react'
import classNames from 'classnames'
import { DEFAULT_ACCENT } from '../../utils/constants'
import { getInitials } from '../../utils/common'
import { truncate } from 'utils/common'
import './style.scss'

const Avatar = ({ onClick, firstName, lastName, showName, color = DEFAULT_ACCENT, truncateLength }) => {
  const fullName = `${firstName} ${lastName}`

  return (
    <div className={classNames('viso-avatar', onClick && 'viso-avatar--clickable')} onClick={onClick}>
      <div className={`viso-avatar__initials viso-text-${color}`}>
        {getInitials(firstName, lastName)}
      </div>
      {showName && <div className='viso-avatar__name'>{truncate(fullName, truncateLength)}</div>}
    </div>
  )
}

export default Avatar